import { useContext } from "react";
import { RefDialogContext } from "../components/Provider";
export const useRefDialog = (id) => {
    const context = useContext(RefDialogContext);
    if (!context) {
        throw new Error("useRefDialog must be used within RefDialogProvider.");
    }
    const open = (element) => { var _a; return (_a = context.refs[id]) === null || _a === void 0 ? void 0 : _a.open(element); };
    const close = () => { var _a; return (_a = context.refs[id]) === null || _a === void 0 ? void 0 : _a.close(); };
    return {
        open,
        close
    };
};
//# sourceMappingURL=useRefDialog.js.map